import React from "react";
import { inputBaseClasses, outlinedInputClasses, Typography } from "@mui/material";
import I18n from "i18next";

import MzAutocomplete from "@markaaz/ui/MzAutocomplete";
import MzButton from "@markaaz/ui/MzButton";
import ReportFrequency from "../business/ReportFrequency";
import Card from "components/common/Card";

const sx = {
  availableQ2: {
    color: "blue.c100",
    marginBottom: "50px",
    display: "flex"
  },
  text: {
    color: "darkBlue.c100",
    margin: "80px 0px 20px 0px",
    display: "flex"
  },
  button: {
    marginTop: "50px"
  },
  autocomplete: {
    [`.${inputBaseClasses.root}.${outlinedInputClasses.root}`]: {
      backgroundColor: "darkBlue.c10"
    },
    maxWidth: "420px"
  }
};

const items = [
  "Active Sanctions",
  "Active Politically Exposed Persons",
  "Active Adverse Media",
  "Active Insolvency Report",
  "Active Law Enforcement"
];

const item = (
  <ul>
    {items.map((val) => {
      return (
        <li key={val}>
          <Typography variant="body2">{val}</Typography>
        </li>
      );
    })}
  </ul>
);

function ComplianceMain() {
  const { t } = I18n;
  return (
    <>
      <MzAutocomplete label="Portfolio" disabled placeholder="Select" sx={sx.autocomplete} />
      <ReportFrequency isChecked={false} reportFrequency="Daily" />
      <Typography variant="body2M" sx={sx.text}>
        {t("monitoringConfiguration.configurationDescription")}
      </Typography>
      <Card content={item} />
      <MzButton variant="contained" size="large" disabled={true} sx={sx.button}>
        {t("applicationOnboarding.confirmConfiguration")}
      </MzButton>
    </>
  );
}

export default ComplianceMain;
